var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.2865,
    height: 45.2865,
    rx: 9.57895,
    fill: "#FFC700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.125H17.4375M22.5 29V16H27.5625C28.4576 16 29.316 16.3424 29.949 16.9519C30.5819 17.5614 30.9375 18.388 30.9375 19.25V20.875C30.9375 21.737 30.5819 22.5636 29.949 23.1731C29.316 23.7826 28.4576 24.125 27.5625 24.125H22.5M36 16V29M17.4375 29V20.0625C17.4375 18.9851 16.993 17.9517 16.2019 17.1899C15.4107 16.428 14.3376 16 13.2188 16C12.0999 16 11.0268 16.428 10.2356 17.1899C9.44447 17.9517 9 18.9851 9 20.0625V29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/api-icon.a0f212263e12b7db79b5213165a3cc31.svg";
export { ForwardRef as ReactComponent };